import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OpeningAnimation from './components/OpeningAnimation';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BookNow from "./pages/BookNow";
import About from './pages/About';
// import other pages
import './App.css';
import Contact from './pages/Contact';

export default function App(){
  const [showOpening, setShowOpening] = useState(true);
  return (
    <BrowserRouter>
      {showOpening ? (
        <OpeningAnimation onFinish={() => setShowOpening(false)} />
      ) : (
        <>
          <Navbar />
          <main className="container main-area">
            <Routes>
              <Route path="/" element={<Home/>} />
              <Route path="/book" element={<BookNow />} />
              <Route path="/About" element={<About />} />
              <Route path="/Contact" element={<Contact />} />
            
              {/* other routes */}
            </Routes>
          </main>
        </>
      )}
    </BrowserRouter>
  );
}
